<template>
  <div>
    <el-form
      ref="receviceRuleFormRef"
      :model="receviceRuleForm"
      class="demo-receviceRuleForm"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col v-if="changeType === 2" :span="8">
          <!--姓名-->
          <el-form-item
            :label="$t('placeOrder.name')"
            prop="receiveName"
            :rules="receiveNameRules"
          >
            <el-input
              v-model="receviceRuleForm.receiveName"
              :placeholder="$t('placeOrder.pleaseInput')"
              clearable
              maxlength="50"
              show-word-limit
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <!--手机-->
        <el-col v-if="changeType === 2" :span="8">
          <el-form-item
            :label="$t('GlobalSetObj.MobilePhone')"
            :rules="isPhone"
            prop="receiveMobile"
          >
            <el-input
              v-model="receviceRuleForm.receiveMobile"
              :placeholder="$t('placeOrder.pleaseInput')"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col v-if="changeType === 2" :span="8">
          <!-- 税号 -->
          <el-form-item :label="$t('placeOrder.TaxCPF')" :rules="isTax12" prop="receiveTax">
            <el-input
              v-model.trim="receviceRuleForm.receiveTax"
              :placeholder="$t('newOrder.PleaseEnter12Or14DigitTaxNumber')"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$t('placeOrder.zipcode')"
            :rules="isZipCode"
            prop="receiveZipcode"
            style="width: 100%"
          >
            <el-input
              v-model.trim="receviceRuleForm.receiveZipcode"
              :placeholder="$t('placeOrder.pleaseInput')"
              clearable
              @change="changeZipCode"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$t('placeOrder.State')"
            :rules="{
              required: true,
              message: $t('placeOrder.pleaseInput'),
              trigger: ['blur', 'change']
            }"
            prop="receiveState"
            style="width: 100%"
          >
            <el-select
              v-model="receviceRuleForm.receiveState"
              :placeholder="$t('placeOrder.pleaseInput')"
              clearable
              filterable
              style="width: 100%"
              @change="stateChangeOption"
            >
              <el-option
                v-for="item in senderStateList"
                :key="item.id"
                :label="item.shortName"
                :value="item.shortName"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$t('placeOrder.city')"
            prop="receiveCity"
            style="width: 100%"
            :rules="cityComplement"
          >
            <el-select
              v-model="receviceRuleForm.receiveCity"
              :placeholder="$t('placeOrder.pleaseChoose')"
              :remote-method="getSenderCity"
              class="formTable"
              filterable
              remote
              reserve-keyword
              style="width: 100%"
              @visible-change="getSenderCity()"
            >
              <el-option
                v-for="item in cityList"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$t('placeOrder.Area')"
            :rules="addressComplement"
            prop="receiveArea"
            style="width: 100%"
          >
            <el-input
              v-model="receviceRuleForm.receiveArea"
              :placeholder="$t('placeOrder.pleaseInput')"
              clearable
              maxlength="32"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('newOrder.Street')" prop="receiveStreet" style="width: 100%">
            <el-input
              v-model="receviceRuleForm.receiveStreet"
              :placeholder="$t('newOrder.ConfirmStreetNumber')"
              clearable
              maxlength="50"
              show-word-limit
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$t('placeOrder.HouseNumber')"
            :rules="checkStr5"
            prop="receiveHouseNumber"
            style="width: 100%"
          >
            <el-input
              v-model="receviceRuleForm.receiveHouseNumber"
              :placeholder="$t('placeOrder.pleaseInput')"
              clearable
              maxlength="6"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$t('placeOrder.addressComplement')"
            :rules="addressComplement"
            prop="receiveComplement"
            style="width: 100%"
          >
            <el-input
              v-model="receviceRuleForm.receiveComplement"
              :placeholder="$t('placeOrder.pleaseInput')"
              clearable
              maxlength="32"
              show-word-limit
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item
            :label="$t('placeOrder.detailedAddress')"
            :rules="isReceiveAddress"
            prop="receiveAddress"
            style="width: 100%"
          >
            <el-input
              v-model.trim="receviceRuleForm.receiveAddress"
              :placeholder="$t('placeOrder.pleaseInput')"
              clearable
              maxlength="200"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import {
  checkAddressComplement,
  E_Mail,
  isTax,
  MobilePhoneNumber
} from '@/utils/validate';
import { getAddressByZipCode, selectCity } from '@/api/orderApi';
import { updateReceiveAddress } from '@/api/logisticsOrders';
export default {
  name: 'EditRecipientInformation',
  props: {
    receviceRuleForm: {
      type: Object,
      default: () => {
        return {
          receiveTax: '',
          receiveMobile: '',
          receiveName: '',
          receiveZipcode: '', // 邮编
          receiveStreet: '', // 街道（精确到街道号）
          receiveHouseNumber: '', // 门牌号
          receiveState: '', // 州
          receiveCity: '', // 城市
          receiveArea: '', // 区
          receiveComplement: '',
          receiveAddress: '' // 详细地址
        };
      }
    },
    senderStateList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    selectionList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    oldZipCode: {
      type: String,
      default: null
    },
    changeType: {
      type: Number,
      default: 1
    }
  },
  created() {
    console.log(this.changeType, '===changeType');
  },
  data() {
    // 邮编校验
    const checkPostcode = async(rule, value, callback) => {
      const reg = /^\d{8}$/;
      if (!value) {
        return callback(new Error(this.$t('collectionCenter.notNull'))); // 不能为空
      } else {
        if (!reg.test(value)) {
          return callback(new Error(this.$t('mdfeTranslate.PostalCodeFormatIsIncorrect'))); // 邮编格式不正确
        } else {
          // await this.zipcodeReceiveChange(value);
          return callback();
        }
      }
    };
    return {
      cityList: [],
      receiveNameRules: [
        { required: true, message: this.$t('placeOrder.pleaseInput'), trigger: ['blur', 'change'] }
      ],
      // 邮箱 E_Mail
      checkMail: [{ required: false }, { validator: E_Mail, trigger: ['blur', 'change'] }],
      // 城市
      cityComplement: [
        { required: true, message: this.$t('placeOrder.pleaseInput'), trigger: ['blur', 'change'] }
      ],
      // 地址补充
      addressComplement: [
        { required: false },
        { validator: checkAddressComplement, trigger: ['blur', 'change'] }
      ],
      // 校验5个字符
      checkStr5: [
        {
          required: false,
          message: this.$t('placeOrder.pleaseInput'),
          trigger: ['blur', 'change']
        },
        { min: 1, max: 5, message: this.$t('placeOrder.input5'), trigger: ['blur', 'change'] }
      ],
      isZipCode: [
        // { required: true, message: this.$t('placeOrder.pleaseInput'), trigger: ['blur', 'change'] }
        { required: true, validator: checkPostcode, trigger: ['change'] }
      ],
      isReceiveAddress: [
        { required: true, message: this.$t('placeOrder.pleaseInput'), trigger: ['blur', 'change'] }
      ],
      isPhone: [
        { required: true, message: this.$t('placeOrder.pleaseInput'), trigger: ['blur', 'change'] },
        { validator: MobilePhoneNumber, trigger: ['blur', 'change'] }
      ],
      isTax12: [
        // 112125456431
        {
          required: true,
          message: this.$t('newOrder.TheTaxIDCannotBeEmpty'),
          trigger: ['blur', 'change']
        },
        { validator: isTax, trigger: ['blur', 'change'] }
      ]
    };
  },
  methods: {
    // 邮编变化
    changeZipCode() {
      const reg = /^\d{8}$/;
      if (reg.test(this.receviceRuleForm.receiveZipcode)) {
        this.zipcodeReceiveChange(this.receviceRuleForm.receiveZipcode);
      }
    },
    // 通过邮编获取收件人地址信息
    zipcodeReceiveChange(zipcode) {
      getAddressByZipCode(zipcode).then((res) => {
        if (res.code === 200) {
          if (res.data.state) {
            this.receviceRuleForm.receiveState = res.data.state;
          }
          if (res.data.city) {
            this.receviceRuleForm.receiveCity = res.data.city;
          }
          if (res.data.area) {
            this.receviceRuleForm.receiveArea = res.data.area;
          }
          if (res.data.street) {
            this.receviceRuleForm.receiveStreet = res.data.street;
          }
          if (res.data.houseNumber) {
            this.receviceRuleForm.receiveHouseNumber = res.data.houseNumber;
          }
          if (res.data.formattedAddress) {
            this.receviceRuleForm.receiveAddress = res.data.formattedAddress;
          }
        }
      });
    },
    // 州省变化获取城市
    stateChangeOption() {
      let id = null;
      this.cityList = [];
      this.receviceRuleForm.receiveCity = '';
      this.senderStateList.map((item) => {
        if (item.shortName === this.receviceRuleForm.receiveState) {
          id = item.id;
        }
      });
      const params = {
        pageNumber: 1,
        pageSize: 200,
        params: {
          id,
          name: ''
        }
      };
      selectCity(params, false).then((res) => {
        if (res.code === 200) {
          this.cityList = res.data.records;
        }
      });
    },
    // 获取城市
    getSenderCity(name = '') {
      let id = null;
      this.senderStateList.map((item) => {
        if (item.shortName === this.receviceRuleForm.receiveState) {
          id = item.id;
        }
      });
      const params = {
        pageNumber: 1,
        pageSize: 200,
        params: {
          id,
          name
        }
      };
      selectCity(params, false).then((res) => {
        if (res.code === 200) {
          this.cityList = res.data.records;
        }
      });
    },
    // 确定提交修改收件人信息
    confirmEdit() {
      this.$refs['receviceRuleFormRef'].validate((valid) => {
        if (valid) {
          const data = {
            ...this.receviceRuleForm,
            updateZipCode: 0
          };
          const orderIds = [];
          const waybillNumberList = [];
          this.selectionList.map((item) => {
            if (item.orderId) {
              orderIds.push(item.orderId);
            } else {
              orderIds.push(item.id);
            }
            if (this.changeType === 1) {
              waybillNumberList.push(item.waybillNumber);
            } else {
              item.waybillList.map(list => {
                if (waybillNumberList.includes(list) === false) {
                  waybillNumberList.push(list);
                }
              });
            }
          });
          data.orderIds = orderIds;
          data.waybillNumbers = waybillNumberList;
          data.needUpdateReceiver = this.changeType !== 1;
          if (orderIds.length > 1) {
            data.updateZipCode = 1;
          } else {
            if (this.oldZipCode !== data.receiveZipcode) {
              data.updateZipCode = 1;
            }
          }
          updateReceiveAddress(data).then((res) => {
            if (res.code === 200) {
              this.$emit('updateTable', res.data, true);
            }
          });
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
